'use strict';

var React = require('react');
var cookieThemeManager = require('./cookieThemeManager.cjs');

/**
 * Returns the preferred color scheme of the user
 */ const usePreferredColorScheme = ()=>{
    const mediaQuery = typeof window !== "undefined" ? window?.matchMedia("(prefers-color-scheme: dark)") : null;
    const userPrefersDark = mediaQuery?.matches ?? false;
    const [preferredColorScheme, setPreferredColorScheme] = React.useState(userPrefersDark ? "dark" : "light");
    const [isPrefersDark, setIsPrefersDark] = React.useState(userPrefersDark);
    React.useEffect(()=>{
        const themeCookie = cookieThemeManager.getThemeCookie();
        if (!themeCookie && userPrefersDark) {
            cookieThemeManager.setThemeCookie(userPrefersDark ? "dark" : "light");
        }
    }, [
        cookieThemeManager.setThemeCookie,
        cookieThemeManager.getThemeCookie,
        userPrefersDark
    ]);
    React.useEffect(()=>{
        const onChange = (event)=>{
            setIsPrefersDark(event.matches);
            setPreferredColorScheme(event.matches ? "dark" : "light");
            cookieThemeManager.setThemeCookie(event.matches ? "dark" : "light");
        };
        mediaQuery?.addEventListener("change", onChange);
        return ()=>mediaQuery?.removeEventListener("change", onChange);
    }, []);
    const isPrefersLight = !isPrefersDark;
    return {
        preferredColorScheme,
        isPrefersDark,
        isPrefersLight
    };
};

exports.usePreferredColorScheme = usePreferredColorScheme;
//# sourceMappingURL=usePreferredColorScheme.cjs.map
